import axios from 'axios';
import { useEffect, useState } from 'react';
import {app} from '../config'
import getHeaders from '../utils/authHeaders';
const fetchEthinicity = () => {
    const [loading, setLoading] = useState(true);
    const [response, setResponse] = useState(null);
    const [error, setError] = useState(null);
    useEffect(() => {
        const getEthinicity = async () => {
          try {
            const res = await axios.get(`${app.URL}/api/v1/admin/ethnicity/getallethnicities`, {headers: getHeaders()});
            setResponse(res.data.result);
            setLoading(false);
          } catch (err) {
            setError(err);
            setLoading(false);
          }
        };
        getEthinicity();
      }, []);
    
      return { loading, response, error };
    };
export default fetchEthinicity;